module.exports = __webpack_public_path__ + "img/client (6).528a1b68.jpg";